import { render, staticRenderFns } from "./ExpandingDisclaimer.vue?vue&type=template&id=7a73c850&scoped=true&"
import script from "./ExpandingDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ExpandingDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingDisclaimer.vue?vue&type=style&index=0&id=7a73c850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73c850",
  null
  
)

export default component.exports